module.exports = __webpack_public_path__ + "kr.e369e47427b306ef9dde.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/kr.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/kr.svg
// module chunks = styles